/**
 * Tranches colorimétriques pour `TimePressedTimer` (MVP2.6 Gap 1).
 *
 * Fichier séparé du composant React pour respecter
 * `react-refresh/only-export-components` (un fichier composant n'exporte
 * que des composants — les helpers vivent à part).
 */

export type TimePressedColorTier = 'normal' | 'warning' | 'critical';

/**
 * Calcule la tranche colorimétrique à partir du temps restant.
 *
 * Seuils (cf. brief MVP2.6 Gap 1) :
 *   - > 10 000 ms   → normal (cyan)
 *   - 5 001..10 000 → warning (ambre)
 *   - ≤ 5 000       → critical (corail)
 */
export function pickColorTier(remainingMs: number): TimePressedColorTier {
  if (remainingMs <= 5000) return 'critical';
  if (remainingMs <= 10000) return 'warning';
  return 'normal';
}
